export default [
    {
      path: '/admin/table-bookings',
      name: 'table-booking',
      meta: { requiresAuth: true },
      component: () => import('@/pages/booking/table-booking')
    }
  ]
  